import { createFileRoute, redirect } from '@tanstack/react-router'
import { LIST, restoreFilters } from '@thom/folio-ui/routing/list-filters'
import { Journal } from '@thom/folio-ui/pages/journal'

export const Route = createFileRoute('/_authenticated/$client/$domain/$slug/journal/')({
	beforeLoad: ({ search, cause, params, context }) => {
		if (cause !== 'enter') return
		const restored = restoreFilters(context.container.listMemory, LIST.JOURNAL, search)
		if (restored) throw redirect({ to: '/$client/$domain/$slug/journal', params, search: restored })
	},
	component: Journal,
})
